'use strict';
var base = require('./base');
var stockStore = require('./stockStore');
var pdpZoom = require('../pdpZoom/pdpZoom');
var scrollAnimate = require('base/components/scrollAnimate');

pdpZoom.initZoom();

window.addEventListener("load", (event) => {
    if (typeof paypal !== 'undefined' && $('.pp-message').length > 0) {
        paypal.Messages({
            amount: $('.pp-message').data('initial-price'),
            placement: "product",
            style: {
                layout: "text",
                text: {
                    color: "greyscale",
                    size: "13",
                    align: "center"
                },
                logo: {
                    type: "none"
                }
            }
        })
            .render(".pp-message");
    }
    var octipasEnabled = $('#store_selector').length > 0;
    if (!octipasEnabled) {
        return;
    }
    if (typeof octipas === 'undefined') {
        console.log('octipas not loaded');
        return;
    }
    stockStore.init();
});

/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
    $('button.add-to-cart-global').attr('disabled', enableOrDisable);
}

function backInStockSubscribe() {
    var formData = {
        pid: $("#pid").val(),
        email: $("#email").val(),
        csrf_token: $("#csrf_token").val()
    }

    $.ajax({
        type: "POST",
        url: $("#backinstock-subscribe-form").data("bisubscribe-url"),
        dataType: "json",
        data: formData,
        success: function (data) {
            $('#bis-modal-body').find('form').hide();
            $('.isBIS').find('.is-back-en-stock').hide();
            $('#backInStockAlert').find('.size-info-bis').hide();
            $('#backInStockAlert').find('.attribute-variation-size').hide();
            $('#backInStockAlert').find('.pdp-omnibus').hide();
            $('#bis-msg').empty();
            $('#bis-msg').html(data.msg);
            $('#continue-shopping-cta').attr('hidden', false);
        },
        error: function (data) {
            window.location.reload();
        }
    });
}
function SizeSelected() {
    if ($(".size-field.selected").length > 0) {
        $('.skp-selcet-size').addClass('d-none');
        $('.skp-selcet-size').addClass('d-block');
        $('.js-select-size').addClass('hide');
        $('.js-btnaddtocart').removeClass('hide');
        $('.store-stock p').removeClass('show-message-stockStore');
        $('.error-message-store').addClass('d-none');
        $('.in-stock-indicator').removeClass('d-none');
        $('.availability-text').removeClass('d-none');
        $('.error-message-store').removeClass('red-message');
        $('.error-message-e-resa').removeClass('red-message');
        $('.add-to-cart,.E-rasa-button,.overlay-btn-backInstock').removeClass('scrollSize');
        if (!$('.js-backInstock').hasClass('d-none')) {
            $('#ereservation_pickup').addClass('full-width');
            $('.js-backInstock').addClass('full-width');
            $('.btn-mobile-pay').removeClass('E-resa-mobile');
        } else {
            $('#ereservation_pickup').removeClass('full-width');
            $('.js-backInstock').removeClass('full-width');
            if ($('.e-reservation').length) {
                $('.btn-mobile-pay').addClass('E-resa-mobile');
            }
        }
    } else {
        $('.skp-selcet-size').removeClass('d-none');
        $('.skp-selcet-size').removeClass('d-block');
        $('.js-btnaddtocart').addClass('hide');
        $('.js-select-size').removeClass('hide');
        $('.error-message-store').removeClass('d-none');
        $('.in-stock-indicator').addClass('d-none');
        $('.availability-text').addClass('d-none');
        $('.add-to-cart').prop('disabled', false);
        if ($(window).width() < 840) {
            $('.add-to-cart,.E-rasa-button,.overlay-btn-backInstock').addClass('scrollSize');
            $('.add-to-cart').prop('disabled', false);
        }
        if (!$('.js-backInstock').hasClass('d-none')) {
            $('#ereservation_pickup').addClass('full-width');
            $('.js-backInstock').addClass('full-width');
            $('.btn-mobile-pay').removeClass('E-resa-mobile');
        } else {
            $('#ereservation_pickup').removeClass('full-width');
            $('.js-backInstock').removeClass('full-width');
            if ($('.e-reservation').length) {
                $('.btn-mobile-pay').addClass('E-resa-mobile');
            }
        }
    }
}

$(document).ready(function () {
    // Gestion des popins (e-reservation et size guide)
    const popins = {
        'ereservation': {
            button: '.E-rasa-button',
            popin: '#Octipas_checkout_fullscreen',
            iframe: '#Octipas_checkout_fullscreen_content_iframe',
            close: '#Octipas_checkout_fullscreen .close-button',
            sizeCheck: true // Nécessite une taille sélectionnée
        },
        'sizeguide': {
            button: '#fitAnalytics__button',
            popin: '#sizeGuidePopin',
            iframe: null, // Pas d'iframe pour le size guide
            close: '#sizeGuidePopin .close-button',
            sizeCheck: false // Ne nécessite pas de taille sélectionnée
        }
    };

    // Ouvrir un popin
    $(document).on("click", Object.values(popins).map(p => p.button).join(','), function (e) {
        e.preventDefault();
        const popinType = $(this).is(popins.ereservation.button) ? 'ereservation' : 'sizeguide';
        const config = popins[popinType];

        // Vérification de la taille si nécessaire
        if (config.sizeCheck && $(".size-field.selected").length === 0) {
            $('.error-message-e-resa').addClass('red-message');
            $('.skp-selcet-size').addClass('show-select-size');
            return;
        }

        $('.error-message-e-resa').removeClass('red-message');
        $(config.popin).removeClass('d-none');

        setTimeout(function () {
            $(config.popin).find('.iframe-resa').addClass('show-e-resa');
        }, 200);

        $('body').addClass('overflow-hide-resa');
        $('.skp-selcet-size').removeClass('show-select-size');
    });

    // Fermer un popin
    $(document).on('click', Object.values(popins).map(p => p.close).join(','), function () {
        const popin = $(this).closest('.E-resa-popin');
        popin.find('.iframe-resa').removeClass('show-e-resa');

        setTimeout(function () {
            popin.addClass('d-none');
            $('body').removeClass('overflow-hide-resa');
        }, 200);
    });

    // Fermer quand on clique en dehors
    $(document).on('click', function (e) {
        Object.values(popins).forEach(config => {
            if (!config.popin) return;

            const popinElement = $(config.popin);
            const isClickInside =
                $(e.target).is(config.button) ||
                $(e.target).closest(config.button).length ||
                $(config.iframe) && ($(e.target).is(config.iframe) || $(config.iframe).has(e.target).length > 0) || $(e.target).closest('.iframe-resa').length;

            if (!isClickInside && !popinElement.hasClass('d-none')) {
                popinElement.find('.iframe-resa').removeClass('show-e-resa');

                setTimeout(function () {
                    popinElement.addClass('d-none');
                    $('body').removeClass('overflow-hide-resa');
                }, 200);
            }
        });
    });
});


window.addEventListener('message', function (event) {
    if (event.data === "closeCheckoutIframe") {
        var elem = document.getElementById('Octipas_checkout_fullscreen');
        $('.iframe-resa').removeClass('show-e-resa');
        setTimeout(function () {
            elem.classList.add('d-none');
        }, 200);
        $('body').removeClass('overflow-hide-resa');
    }
})

module.exports = {
    methods: {
        updateAddToCartEnableDisableOtherElements: updateAddToCartEnableDisableOtherElements
    },

    availability: base.availability,

    addToCart: base.addToCart,

    initModal: function () {
        $('body').on('shown.bs.modal', '#backInStockAlert', function (e) {
            var variantPid = $(e.relatedTarget).attr('data-variant-pid');
            $('#backInStockAlert #pid').val(variantPid);
        });
        $('body').on('hidden.bs.modal', '#backInStockAlert', function (e) {
            var textBis = $('#bis-msg').data('text-bis');
            $('#bis-modal-body').find('form').show();
            $('#bis-msg').html(textBis);
            $('#continue-shopping-cta').attr('hidden', true);
        });

        $(document).on("click", ".add-to-back-in-stock", function () {
            var errorMessage = "";
            //this stops the form from being submitted, to allow for validation
            event.preventDefault();
            //validation, stackoverflow code
            function isValidEmailAddress(emailAddress) {
                var pattern = new RegExp(/^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/);
                return pattern.test(emailAddress);
            };
            //email validation
            if (!isValidEmailAddress($("#email").val())) {
                errorMessage = errorMessage + $("#backinstock-subscribe-form").data('form-notifyme');
            };
            $("#error").html(errorMessage);

            var $pdp = $('.isPDP');
            var $selectSizeContainer = $pdp.find('.skp-selcet-size');
            var $selectedSize = $(".size-field.selected");

            if ($selectedSize.length === 0) {
                // Add 'show-select-size' class if no size is selected
                $selectSizeContainer.addClass('show-select-size');
            }
            else {
                // Remove 'show-select-size' class if a size is selected
                $selectSizeContainer.removeClass('show-select-size');
            }

            //submit form
            if (errorMessage == "" && $selectedSize.length !== 0) {
                backInStockSubscribe();
            }
            //alert user to errors, form doesn't get submitted
            else {
                $("#error").html(errorMessage);
            }
        });

        $(document).on("click", ".continue-shopping-cta", function () {

            const popupInstance = $.popup();
            if (popupInstance.isOpen()) {
                setTimeout(function () {
                    popupInstance.close();
                }, 300);
            }

        });

    },

    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

            $productContainer.find('.description-and-detail .product-attributes')
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find('.description-and-detail .description')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .description .content .content-description')
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find('.description-and-detail .description')
                    .addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                $productContainer.find('.description-and-detail .details')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .details .content')
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer.find('.description-and-detail .details')
                    .addClass('hidden-xl-down');
            }
        });
    },

    showSpinner: function () {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
            $.spinner().start();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
            }
            SizeSelected();

            $('.availability-msg-limited-stock').empty().removeClass('mao-exist');
            var maoMessage = $('.availability-msg-limited-stock');
            if (maoMessage.length > 0) {
                maoMessage.each(function () {
                    if ($(this).text().trim() === "") {
                        $('.availability-msg').removeClass('d-none');
                        $('.availability-msg-limited-stock').removeClass('mao-exist');
                    } else {
                        $('.availability-msg').addClass('d-none');
                        $('.availability-msg-limited-stock').addClass('mao-exist availability-msg-red');
                    }
                });
            }
        });

        if ($(".size-field").length == 1 && $(".size-field.selected").length > 0) {
            $('.availability-text').removeClass('d-none');
            $('.error-message-store').addClass('d-none');
            $('.in-stock-indicator').removeClass('d-none');
        } else {
            $('.availability-text').addClass('d-none');
            $('.error-message-store').removeClass('d-none');
            $('.in-stock-indicator').addClass('d-none');
        }
        SizeSelected();
        $(document).on("click", ".size-field", function (event) {
            $('.select-size').val($(this).data("attr-value")).trigger('change');
            $(".size-field").removeClass("selected");
            $(this).addClass("selected");
        });

        var colorSwatch = $('.swatch-circle');
        colorSwatch.each(function () {
            var self = $(this),
                colorValue = self.data("attr-value"),
                strColor = colorValue.substring(0, 3);

            if (strColor === "WHI") {
                self.addClass('swatch-white');
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            var displaybutton = ((!response.product.readyToOrder || !response.product.available) && $('button.add-to-cart').data('backinstock'));

            if (displaybutton) {
                $('button.add-to-cart').addClass('d-none');
                $('.js-backInstock').removeClass('d-none');
                $('#ereservation_pickup,.js-backInstock').addClass('full-width');
            } else {
                $('button.add-to-cart', response.$productContainer).attr('disabled',
                    (!response.product.readyToOrder || !response.product.available));
                $('.js-backInstock').addClass('d-none');
                $('button.add-to-cart').removeClass('d-none');
                $('#ereservation_pickup,.js-backInstock').removeClass('full-width');
            }

            var wdithofwindow = $(window).width();
            const popupInstance = $.popup();

            if (!popupInstance.isOpen()) {
                if (wdithofwindow <= 544) {
                    $('.prices-add-to-cart-actions .btn-mobile-pay').first().insertAfter('.js-backInstock');
                } else {
                    $('.prices-add-to-cart-actions .btn-mobile-pay').first().insertBefore('js-backInstock');
                }
            }
            $('button.add-to-cart', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));

            var enable = $('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });
            module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            var isAvailable = response.product.available || false;
            var availabilityMessages = response.product.availability.messages || [];

            var stockLimitedMessage = availabilityMessages.find(function (message) {
                return message.key === 'stockLimited';
            });

            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);

            let color;
            if (isAvailable && stockLimitedMessage) {
                color = 'orange';
            }

            // Optionnel : Affichage du message dans le DOM (commenté)
            // $('.availability-msg', response.$productContainer)
            //;

            let dot = `<span style="display:inline-block; width:10px; height:10px; border-radius:50%; background-color:${color}; margin-right:8px;"></span>`;
            if (response.message && stockLimitedMessage) {
                const messageHtml = `${dot}${response.message}`;
                $('.availability-msg', response.$productContainer).empty().append(messageHtml);
                $('.isPDP .availability-msg').empty().append(messageHtml);
            } else {
                $('.availability-msg').empty();
            }

            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability').toArray()
                    .every(function (item) {
                        return $(item).data('available');
                    });

                var allReady = $('.product-availability').toArray()
                    .every(function (item) {
                        return $(item).data('ready-to-order');
                    });

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg').empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);

            }
        });
    },
    sizeChart: function () {
        $('.size-chart a').on('click', function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            var $prodSizeChart = $(this).closest('.size-chart').find('.size-chart-collapsible');
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                    }
                });
            }
            $prodSizeChart.toggleClass('active');
        });

        var $sizeChart = $('.size-chart-collapsible');
        $('body').on('click touchstart', function (e) {
            if ($('.size-chart').has(e.target).length <= 0) {
                $sizeChart.removeClass('active');
            }
        });
    },
    copyProductLink: function () {
        $('body').on('click', '#fa-link', function () {
            event.preventDefault();
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').attr('role', 'alert');
            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },



    focusChooseBonusProductModal: base.focusChooseBonusProductModal()

};

$('#lightgallery li.skp-pdp-iframe').css({ 'position': 'relative', 'z-index': '-1' });


function PLPHeightImage() {
    var window_Width = $(window).width(),
        PLP_width = (1 / 3 * window_Width),
        PLP_width_New = (1 / 2 * window_Width);

    if (window_Width > 840) {
        var PLP_Height = (PLP_width * 1.24);
        $('.skp-product-tile .product-tile .image-container, .product-tile .skp-fullscreen-vimeo,.skp-product-tile .product-tile .slide-box,.skp-product-tile .product-tile .slick-list').css('height', PLP_Height);

        var PLP_Height_New_Grid_Desktop = (PLP_width_New * 1.24);
        $('.newGrid > :nth-child(22n + 7) .image-container, .newGrid > :nth-child(22n + 8) .image-container, .newGrid > :nth-child(22n + 21) .image-container, .newGrid > :nth-child(22n + 22) .image-container,.newGrid > :nth-child(22n + 7) .slick-list, .newGrid > :nth-child(22n + 8) .slick-list, .newGrid > :nth-child(22n + 21) .slick-list, .newGrid > :nth-child(22n + 22) .slick-list,.newGrid > :nth-child(22n + 7) .slide-box, .newGrid > :nth-child(22n + 8) .slide-box, .newGrid > :nth-child(22n + 21) .slide-box, .newGrid > :nth-child(22n + 22) .slide-box').each(function () {
            $(this).css({
                'height': PLP_Height_New_Grid_Desktop + 'px'
            });
        });
    } else {
        var PLP_width = (1 / 2 * window_Width),
            PLP_Height = (PLP_width * 1.24);
        $('.skp-product-tile .product-tile .image-container, .product-tile .skp-fullscreen-vimeo,.skp-product-tile .product-tile .slide-box,.skp-product-tile .product-tile .slick-list').css('height', PLP_Height);

        var PLP_Height_New_Grid_Mobile = (window_Width * 1.24);
        $('.newGrid > :nth-child(22n + 7) .image-container, .newGrid > :nth-child(22n + 8) .image-container, .newGrid > :nth-child(22n + 21) .image-container, .newGrid > :nth-child(22n + 22) .image-container,.newGrid > :nth-child(22n + 7) .slick-list, .newGrid > :nth-child(22n + 8) .slick-list, .newGrid > :nth-child(22n + 21) .slick-list, .newGrid > :nth-child(22n + 22) .slick-list,.newGrid > :nth-child(22n + 7) .slide-box, .newGrid > :nth-child(22n + 8) .slide-box, .newGrid > :nth-child(22n + 21) .slide-box, .newGrid > :nth-child(22n + 22) .slide-box').each(function () {
            $(this).css({
                'height': PLP_Height_New_Grid_Mobile + 'px'
            });
        });

    }
}

$(document).ready(function () {
    PLPHeightImage();
    var wdithofwindow = $(window).width();
    if (wdithofwindow <= 840) {
        $('.description-and-detail .description').addClass('active');
    } else {
        $('.description-and-detail .description').removeClass('active');
    }
});

$(window).on('load resize scroll', function () {
    PLPHeightImage();
});

$(function () {
    const $originalBlock = $('.sticky-add-to-cart');
    const $stickyBlock = $originalBlock.clone().removeClass('d-none').addClass('sticky-add-to-cart').appendTo('body');

    const $reference = $('.prices-add-to-cart-actions').first();
    const $footerLegal = $('footer');

    function isElementInViewport($el) {
        if ($el.length === 0) return false;
        const rect = $el[0].getBoundingClientRect();
        return (
            rect.top < window.innerHeight &&
            rect.bottom > 0
        );
    }

    function checkVisibility() {
        const scrollTop = $(window).scrollTop();
        const referenceBottom = $reference.offset().top + $reference.outerHeight();
        const isSmallScreen = $(window).width() <= 1024;

        if (isSmallScreen) {
            $stickyBlock.hide();
        } else {
            if (scrollTop > referenceBottom && !isElementInViewport($footerLegal)) {
                $stickyBlock.slideDown(300);
            } else {
                $stickyBlock.slideUp(300);
            }
        }
    }

    $(window).on('scroll resize', checkVisibility);
    checkVisibility();
});

var emailInput;
function validateEmail(email) {
    var pattern = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;

    return $.trim(email).match(pattern) ? true : false;
}
$("#email").on("keyup", function () {
    emailInput = $(this).val();

    if (validateEmail(emailInput)) {
        $('.skp-error-msg').hide();
    } else {
        $('.skp-error-msg').show();
    }
});


/**
 * send GTM event view_item_list base on gtm attributes 
 * @param {*} slider 
 */
function pushGtmList(slider) {
    var items = [];
    let listName = $(slider).data("gtmList");
    $(slider).find(".product-tile").each(function (i, v) {
        let itemGtmData = $(this).data("gtm");
        itemGtmData.item_list_name = listName;
        items.push(itemGtmData);
    });
    var listView = {
        event: "view_item_list",
        ecommerce: {
            items: items
        }
    }
    dlWaitThenPush(listView)
}
$(document).ready(function () {
    var sliders = $(".slider-recommendations");
    sliders.each(function (i, slider) {
        pushGtmList(slider);
    });
});

// Function to handle DOM mutations
function handleMutations(mutationsList, observer) {
    mutationsList.forEach((mutation) => {
        if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((addedNode) => {
                if ($(addedNode).is("div.recommendations")) {
                    var items = [];
                    let listName = $(addedNode).is("div.recommendations.container") ? "Upsell - Product Page" : "Last products - Product Page";
                    $(addedNode).find(".product-tile").each(function (i, v) {
                        let itemGtmData = $(this).data("gtm");
                        itemGtmData.item_list_name = listName;
                        items.push(itemGtmData);
                    });
                    var einsteinListView = {
                        event: "view_item_list",
                        ecommerce: {
                            items: items
                        }
                    };
                    dlWaitThenPush(einsteinListView);
                }
            });
        }
    });
}

const targetNode = document.body;

const observer = new MutationObserver(handleMutations);

const config = { childList: true, subtree: true };

observer.observe(targetNode, config);


function deplace() {
    var wdithofwindow = $(window).width();
    if (wdithofwindow <= 840) {
        $('.pp-message,.payment-button').insertAfter('#store_pickup');
    } else {
        $('.pp-message,.payment-button').insertBefore('#store_pickup');
    }
    if (wdithofwindow <= 840) {
        $('#ereservation_pickup').insertBefore('.cart-and-ipay .btn-mobile-pay .btn');
    } else {
        $('.pp-message,.payment-button').insertAfter('#ereservation_pickup');
    }
}
deplace();

$('body').on('click', '.scrollSize', function () {
    var $element = $('.skp-product-detials');
    var headerHeight = $('header').innerHeight();
    $('html, body').animate({
        scrollTop: $element.offset().top - headerHeight
    }, 1000);
});

window.onload = function () {
    if ($(".payment-button").height() > 0) {
        $(".pp-message").removeClass("d-block");
    } else {
        $(".pp-message").addClass("d-block").removeClass("d-none");
    }
};

if (!$('.js-backInstock').hasClass('d-none')) {
    $('#ereservation_pickup').addClass('full-width');
    $('.js-backInstock').addClass('full-width');
}

const checkKleepButton = setInterval(function () {
    const kleepButton = $('.kleep-button');
    const kleepBlock = $('.block-kleep');
    const kleepContent = $('.kleep-content');

    if (kleepButton.length > 0 && kleepContent.length > 0) {

        kleepContent.append(kleepBlock);
        kleepBlock.removeClass('d-none');

        clearInterval(checkKleepButton);

        const kleepDefault = kleepContent.find('.kleep-default');

        const kleepText = kleepContent.attr('data-text-kleep');

        kleepDefault.empty();

        kleepDefault.append(`<span class="kleep-label">${kleepText}</span><span class=kleep-icon></span>`);
    }
}, 100);


if ($('.e-reservation').length && $('.btn-backInstock.full-width').length < 1) {
    $('.btn-mobile-pay').addClass('E-resa-mobile');
}

function handleStickyScroll($stickyCol) {
    $(window).on('scroll', function () {
        const scrollTop = $(window).scrollTop();
        const stickyColTop = $stickyCol.offset().top;

        if (scrollTop >= stickyColTop) {
            $('.page, .product-detail').addClass('overflow-visible');
        } else {
            $('.page, .product-detail').removeClass('overflow-visible');
        }
    }).trigger('scroll');
}

function loadRecommendations($container, url, $target) {
    if ($container.data('loaded')) return;
    $container.data('loaded', true);

    $.get(url)
        .done(function (html) {
        $target.html(html);

            if (url.includes('type=recently')) {
            $target.removeClass('d-none');
            $('.recommendations').removeClass('d-none');
                const carouselSlick = require('../product/carouselSlickRecommendations');
                if (typeof carouselSlick.init === 'function') {
                    carouselSlick.init();
                }
            }
        });
}
function triggerRecommendationsIfVisible() {
    // Bloc RecommendationsList
    var $recList = $('#recommendationsList');
    if ($recList.length && !$recList.data('loaded')) {
        var urlList = $recList.data('url-recommendation-list');
        // Ajoute le paramètre type=list
        if (urlList.indexOf('type=') === -1) {
            urlList += (urlList.indexOf('?') === -1 ? '?' : '&') + 'type=list';
        }
        var $targetList = $recList.find('.products-list');
        loadRecommendations($recList, urlList, $targetList);
    }

    // Bloc recommandationRecentlyViewed
    var $recViewed = $('#recommandationRecentlyViewed');
    if ($recViewed.length && !$recViewed.data('loaded')) {
        var urlViewed = $recViewed.data('url-recommendation-recently-viewed');
        // Ajoute le paramètre type=recently
        if (urlViewed.indexOf('type=') === -1) {
            urlViewed += (urlViewed.indexOf('?') === -1 ? '?' : '&') + 'type=recently';
        }
        var $targetViewed = $recViewed.find('.products-recently-viewed');
        loadRecommendations($recViewed, urlViewed, $targetViewed);
    }
}

// Lazy-load au scroll
$(window).on('scroll', function () {
    triggerRecommendationsIfVisible();
});

// Fallback si pas scrollé au bout de 3 secondes
$(window).on('load', function () {
    triggerRecommendationsIfVisible();

        // Attente que le DOM soit prêt (sticky-col etc.)
            let elapsed = 0;
            const interval = setInterval(function () {
                const $stickyCol = $('#sticky-col');
                const $carousel = $('.image-carousel-thumbnails');
                const $recommandation = $('.list-recommandation-products');
                const $stickyRow = $('.sticky-row');
                elapsed += 100;

                if (
                    $stickyCol.length &&
                    $carousel.length &&
                    $recommandation.length
                ) {
                    clearInterval(interval);
                    const width_block = $carousel.width() - 1;
                    const recommandationBlock = $recommandation.width();
                    // Appliquer la largeur dynamique
                    $recommandation.css('max-width', recommandationBlock + width_block);

                    if ($stickyRow.length) {
                        $stickyRow.css('max-width', width_block);
                        $recommandation.css(
                            'max-width',
                            `calc(100% - ${width_block}px)`
                        );
                        const $window = $(window);
                        var window_Width = $window.width();
                        if (window_Width > 840) {
                            handleStickyScroll($stickyCol);
                        }
                         $('.products-list').removeClass('d-none');
                    }
                }

                if (elapsed > 5000) {
                    clearInterval(interval);
                }
            }, 200);
});